import { Templates } from '@hellohair/types';
import { Box } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AddRowButton, FieldGroup, NextQuestionSelect, RepeatableRow, StepField } from '../_shared/fields';
import { appendTo, normaliseAccept, removeAt, setAt } from '../_shared/stepData';
import { StepDialog, StepEditorProps } from '../_shared/StepDialog';
import { useStepDraft } from '../_shared/useStepDraft';

const Legal: FC<StepEditorProps> = ({ survey, index, onClose }) => {
  const { t } = useTranslation();
  const { draft, set, save, dirty } = useStepDraft<Templates.StepDataLegal>(survey, index, normaliseAccept);
  const accept = (draft.accept as string[]) ?? [];

  return (
    <StepDialog
      survey={survey}
      index={index}
      onSave={save}
      onClose={onClose}
      dirty={dirty}
      edit={
        <>
          <StepField
            label={t('editor.field.legalText')}
            value={draft.question}
            onChange={(value) => set('question', value)}
            multiline
          />

          <FieldGroup title={t('editor.section.accepts')} hint={t('editor.hint.accepts')}>
            {accept.map((entry: string, i: number) => (
              <RepeatableRow key={i} onRemove={() => set('accept', removeAt(accept, i))}>
                <Box sx={{ flexGrow: 1, minWidth: '160px' }}>
                  <StepField
                    label={t('editor.field.acceptText')}
                    value={entry}
                    onChange={(value) => set('accept', setAt(accept, i, value))}
                    multiline
                  />
                </Box>
              </RepeatableRow>
            ))}
            <AddRowButton label={t('editor.add.accept')} onClick={() => set('accept', appendTo(accept, ''))} />
          </FieldGroup>

          <StepField
            label={t('editor.field.extra')}
            value={draft.extra}
            onChange={(value) => set('extra', value)}
            multiline
          />
        </>
      }
      logic={
        <NextQuestionSelect
          steps={survey.steps}
          value={draft.followerId}
          onChange={(followerId) => set('followerId', followerId)}
        />
      }
      settings={
        <StepField label={t('editor.field.buttonLabel')} value={draft.next} onChange={(value) => set('next', value)} />
      }
    />
  );
};

export default Legal;
